import { Box, Modal } from "@mui/material";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import warning from "../../../assets/warning.svg";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

// Maps the backend's `redirect_screen` / `missing` value to a frontend route.
const SCREEN_ROUTE_MAP = {
  company_profile: "/create-profile",
  create_company_profile: "/create-profile",
  create_profile: "/create-profile",
  location: "/location",
  region: "/region",
  face_scanning: "/face-scanning",
  address_location: "/address-location",
};

const DEFAULT_ROUTE = "/create-profile";

const ProfileIncompleteModal = ({ open, onClose, profileStatus }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { t } = useTranslation();

  const handleContinue = () => {
    const key = profileStatus?.redirect_screen || profileStatus?.missing;
    const route = SCREEN_ROUTE_MAP[key] || DEFAULT_ROUTE;
    onClose();
    navigate(route);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          px: 2,
          width: 450,
          maxWidth: "90vw",
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img src={warning} style={{ width: 90, height: 90 }} alt="warning" />
        </Box>

        <CustomText
          sx={{
            ...textStyles,
            fontSize: "24px",
            fontWeight: 500,
            fontFamily: "Poppins, sans-serif",
            color: theme.palette.tertiary.main,
            mb: 2,
            mt: 1,
            textAlign: "center",
            letterSpacing: "0px !important",
          }}
        >
          {t("profileIncomplete.title")}
        </CustomText>
        <CustomText
          sx={{
            ...textStyles.body4,
            color: theme.palette.text.primary,
            mb: 3,
            textAlign: "center",
          }}
        >
          {t("profileIncomplete.defaultMessage", profileStatus?.message)}
        </CustomText>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CustomButton
            label={t("profileIncomplete.cta")}
            onClick={handleContinue}
            size="medium"
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ProfileIncompleteModal;
